import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class AppSettings {
  // static PAGINATION(PAGINATION: any): any[] {
  //   throw new Error('Method not implemented.');
  // }
  public static PAGINATION = 'pagination';
  public static TITLE = 'Mobisoft Cab Booking Management Solution';
  public static BASE_URL = environment.basePath;
  public static TENANT = environment.tenant;
  public static SUPPORTED_COUNTRY = environment.supportedCountry;
  public static TENANT_INFO = 'tenantInfo';
  public static HEADER_CONTENT_TYPE = ' ';
  public static HEADER_AUTHORIZATION = 'Authorization';
  public static HEADER_TIMEZONE = 'Timezone';
  public static HEADER_TIMEZONE_VALUE = '';
  public static HEADER_ACCEPT_LANGUAGE = 'en';
  public static DEFAULT_LANGUAGE = 'en';
  // public static HEADER_ACCEPT_LANGUAGE = 'en-US';
  public static HEADER_AUTHORIZATION_VALUE = '';
  public static USER: any = null;
  public static TOKEN_KEY = 'Token';
  public static USER_DETAILS = 'userDetails';
  public static FILE_UPLOAD_ID = '';
  public static FILE_UPLOAD_NAME = '';
  public static PROFILE_UPLOAD_ID = '';
  public static PROFILE_UPLOAD_NAME = '';
  public static DISTANCE_UNIT = 'distance_unit';
  public static DISTANCE_UNIT_MILES = 'miles';
  public static REFERRAL_CODE = 'driver_referral';
  public static PASSENGER_REFERRAL_CODE = 'passenger_referral';
  public static REFERRAL_MANDATORY = 'referral_mandatory';
  public static NEW_REQUEST_STATUS = '1';
  public static ATTENDED_REQUEST_STATUS = '2';
  public static CLOSED_REQUEST_STATUS = '3';
 public static SYSTEM_ADMIN = "taxiPulseSystemAdmin000000000002";
 
  public static ADMIN_TRIP_ACTION = 'admin_trip_action';
  public static PASSENGER_WALLET = 'passenger_wallet';
  public static TOPUP_PASSENGER_WALLET_BY_ADMIN = 'topup_passenger_wallet_by_admin';
  public static TRIP_NOTE = 'trip_note';
  public static DEFAULT_COUNTRY = 'default_country';
  public static DEFAULT_CURRENCY = 'default_currency';
  public static ADDITIONAL_STOPS = 'additional_stops';
  public static IS_MANAGE_CORPORATES = 'is_corporate_company';
  public static IS_RIDE_PREFERENCE = 'is_ride_preferences_applicable';

  public static BOOKING_FEES_APPLICABLE = 'booking_fees_applicable';
  public static PASSENGER_LIST_TYPE = 'passengerTypeList';
  public static ADDITIONAL_CHARGES = 'additional_charges';
  public static ADDITIONAL_CHARGES_REASON_LIST = 'additionalChargesReasonsList';
  public static POSITIVE_NEGATIVE_NUMBER = /^-?[0-9]\d*(\.\d+)?$/;
  public static NAME = /[a-zA-Z0-9][\\sa-zA-Z0-9]{0,19}/;


  public static TENANT_CONFIG = 'TENANT_CONFIG';
  public static IS_RIDE_SHARE_APPLICABLE = 'is_ride_share_applicable';
  public static IS_AIRPORT_ZONES_APPLICABLE = 'airport_zones_applicable';

  public static IS_DRIVER_EXTRA_DOCUMENT_UPLOAD = 'driver_extra_document_upload';
  public static IS_MANAGE_COMPANY = 'is_bidding_applicable';
  public static IS_PROMOCODE_LISTING = 'promo_code_listing';
  public static IS_SEARCH_DRIVER = 'is_dashboard_driver_search';
  public static IS_MULTIPLE_VEHICLE_TO_DRIVER = 'is_multiple_vehicle_to_driver';
  public static IS_DRIVER_SUBSCRIPTION = 'driver_subscription';
  public static IS_DRIVER_APPROVAL = 'driver_approval';
  public static IS_LANGUAGE_SUPPORT = 'is_language_support';
  public static IS_RENTAL_APPLICABLE = 'is_rental_service_applicable';
  public static IS_TIME_BASED = 'time_based_surge';
  public static IS_DATE_BASED = 'date_based_surge';


  public static SUPPORTED_LANGUAGES = 'supported_languages';
  public static EMAIL_OPTIONAL = 'email_optional_for_role';
  public static DESTINATION_OPTIONAL = 'destination_optional';
  public static PROMOCODE_LISTING = 'promo_code_listing';



  public static FAQ: any = null;
  public static ACCESS_LIST = 'ACCESS_LIST';
  public static IS_REGION_FARE_APPLICATION = 'is_region_fare_applicable';
  public static IS_REGION_PRIORITY = 'is_region_priority';
  public static ACCESS_MENU = 'ACCESS_MENU';
  public static SERVICE_AREA = 'SERVICE_AREA';
  public static SERVICE_AREA_ALIAS = 'SERVICE_AREA_ALIAS';
  public static SERVICE_CITIES_MAP = 'SERVICE_CITIES_MAP';
  public static MUTLTI_SELECT_SERVICE_CITIES = 'MUTLTI_SELECT_SERVICE_CITIES';
  public static SERVICE_AREA_ID = 'SERVICE_AREA_ID';
  public static CURRENT_USER_CORPORATE_ID = 'CURRENT_USER_CORPORATE_ID';
  public static TIME_SETTINGS = 'TIME_SETTINGS';
  public static TAXI = 'tenantServiceTypes00000000000001';
  public static RENTAL = 'tenantServiceTypes00000000000002';
  public static OCCASIONAL_RIDE = 'tenantServiceTypes00000000000003';
  public static IS_BIDDING_ENABLED = 'is_bidding_applicable';
  public static IS_COMPANY_CATEGORY_APPLICABLE = 'vehicle_type_categories_applicable';
  public static DATE_FORMAT = 'date_format';
  public static TIME_FORMAT = 'time_format';

  public static SETTING_SERVICE_ID = '';
  public static SERVICE_TYPE = 'ServiceType';
  public static USER_TYPE_LIST = 'userTypeList';
  public static DELETE_ACCOUNT_BY_ROLE = 'delete_account_by_role';

  public static SETTING_RENTAL_WITHOUT_SERVICE = '';
  public static SETTING_RENTAL_WITH_SERVICE = '';
  public static SETTING_TAXI_SERVICE = '';
  public static SETTING_CHAUFFEUR_SERVICE = '';
  public static SETTING_RENTAL_WITHOUT_SERVICE_KEY = 'Rental without driver';
  public static SETTING_RENTAL_WITH_SERVICE_KEY = 'Rental with driver';
  public static SERVICE_CODE_RENTAL = 'Rental';
  public static SETTING_TAXI_SERVICE_KEY = 'Taxi';
  public static SETTING_STAFF_TRANSPORT_SERVICE_KEY = 'StaffTransport';
  public static SETTING_CHAUFFEUR_SERVICE_KEY = 'Chauffeur';
  public static TAXI_BOOK_MAX_TIME = 'book_later_maximum_time';
  public static TAXI_BOOK_MIN_TIME = 'book_later_minimum_time';
  public static RENTAL_BOOK_MIN_TIME = 'book_later_minimum_time_rental';
  public static CHAUFFEUR_BOOK_MIN_TIME = 'book_later_minimum_time_chauffeur';
  public static AUTOMATIC = 'AUTO';
  public static DRIVER_KEY = 'DRIVER';
  public static PASSENGER_KEY = 'PASSENGER';
  public static MANUAL = 'MANL';
  public static MIN_DISTANCE = 0.1;
  public static MAX_DISTANCE = 1;
  public static UPLOAD_FILE_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT + '/secure/file';
  public static GET_FILE_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT + '/file';
  public static GET_FILE_THUMB_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT + '/file/thumbnail_';
  public static EXPORT_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT;
  public static PRINT_URL = AppSettings.BASE_URL + '/' + AppSettings.TENANT;
  public static DEFAULT_PROFILE_IMAGE_URL = '/assets/images/temp/default_profile.png';
  public static DEFAULT_DOCUMENT_IMAGE_URL = '/assets/images/temp/doc.png';
  public static ON_ERROR_DOC_IMAGE = 'src=\'/assets/images/temp/doc.png\'';
  public static DEFAULT_VEHICLE_IMAGE_URL = '/assets/images/temp/default_staff_transport.png';
  public static CLEAR_NOTIFICATION_INTERVAL: any;
  public static WEBSITE_PATTERN = new RegExp(['^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?',
    '[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})',
    '?(\/.*)?$'].join(''));
  public static WEBSITE_PATTERN_URL = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)+[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
  // public static NAME_PATTERN = new RegExp(['^[A-Za-z\\d\-_\\s]*$'].join(''));
  // public static NAME_PATTERN = new RegExp(/^([a-zA-Z]+[a-zA-Z0-9]+\s?)*$/);
  public static NAME_PATTERN = new RegExp(['^[A-Za-zầáéíóúñüÁÉÍÓÚÑÜ]'].join(''));
  public static CARD_EXPIRATION_PATTERN = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
  // public static CARD_NUMBER_PATTERN = /^([0-9]{4}[\s-]?){3}([0-9]{4})$/ ;
  public static CARD_NUMBER_PATTERN = /^([0-9]{4}[\s-]?){3}(?:[0-9]{1,4})$/;


  // public static NAME_PATTERN = new RegExp(/^([a-zA-Z0-9]+\s?)*$/);
  public static ROLE_PATTERN = new RegExp(['^[A-Za-z\\d\-_\\s/\\\\\]*$'].join(''));
  public static PHONE_PATTERN: any = '^[0-9][0-9]*$';
  public static NUMBER_PATTERN = /^\+?[0-9\-]+$/;
  public static AMOUNT_PATTERN = new RegExp(['^[0-9\\d\.]*$'].join(''));
  public static PERCENT_PATTERN = new RegExp(['^[0-9][0-9]?$|^100$'].join(''));
  public static WALLET_AMOUNT_PATTERN = new RegExp(['^[-|0-9\\d\.]*$'].join(''));
  public static PHONE_CODE = /([0-9]{4,})|[1-9]/;
  public static EMAIL_PATTERN = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,5})+$/;

  // public static EMAIL_PATTERN = new RegExp(['[a-z|A-Z|0-9]+[@]+[a-z|A-Z|0-9|-]+[.]+[a-z|A-Z|0-9]+'].join(''));
  // public static EMAIL_PATTERN = new RegExp(['/^\S+@\S+\.\S+$/'].join(''));
  // public static EMAIL_PATTERN = new RegExp(/^\w+([//+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/);
  public static ZIPCODE_PATTERN = new RegExp(['^[0-9]'].join(''));
  public static DIGIT_PATTERN = new RegExp(['^[\\d]*$'].join(''));
  public static RADIUS_DIGIT_PATTERN = /^[0-9|.|0-9]+$/;
  public static NUMBER_NOT_ZERO = new RegExp(['^[1-9][0-9]*$'].join(''));
  public static FEE_PATTERN = new RegExp(['^\\d+(\.\\d{1,2})?$'].join(''));
  public static ALPHA_NUMERIC = new RegExp(['^[A-Za-z0-9]'].join(''));
  public static VALUE_ONE_TO_HUNDRED = new RegExp(['^[1-9][0-9]?$|^100$'].join(''));
  public static NON_ZERO_VALUES = new RegExp(['^[1-9][0-9]*$'].join(''));
  public static HOTEL_PROFILE_UPLOAD_ID = '';
  public static HOTEL_PROFILE_UPLOAD_NAME = '';
  public static PERSON_NAME_PATTERN = '^[a-zA-Z][a-zA-Z\\s\-\_]+$';
  public static COMPANY_AND_PERSON_NAME_PATTERN = '^[a-zA-Z0-9][a-zA-Z0-9\\s\-\_]+$';
  public static FAX_PATTERN = /^\+?[0-9\-]+$/;
  public static TIME_ZONE_FIRST_STRING = /[(]/gi;
  public static TIME_ZONE_SECOND_STRING = /[)]/gi;
  public static NO_WHITESPACE = '^[A-Z0-9]*$';
  public static NO_WHITESPACE_INSENSITIVE = '^[A-Za-z0-9]*$';
  public static NO_SPECIAL_CHAR_AND_WHITESPACE = new RegExp(['^[A-Za-z0-9]*$'].join(''));

  public static DEFAULT_POWERED_BY_REDIRECT_URL = 'https://mobisoftinfotech.com/solutions/event-transportation-management-app';
  public static DEFAULT_POWERED_BY_LOGO_URL = '/assets/images/temp/powered-by-mi.svg';
  // public static NO_SPACE = '^[a-zA-Z0-9]*$';
  public static DAYS_COLLECTION = [
    { label: 'Sun', value: '1' },
    { label: 'Mon', value: '2' },
    { label: 'Tue', value: '3' },
    { label: 'Wed', value: '4' },
    { label: 'Thu', value: '5' },
    { label: 'Fri', value: '6' },
    { label: 'Sat', value: '7' }
  ];

  public static COUNTRY_CODE = [
    { label: 'Code', value: '' },
    { label: '+1', value: '+1' },
    { label: '+7', value: '+7' },
    { label: '+20', value: '+20' },
    { label: '+27', value: '+27' },
    { label: '+30', value: '+30' },
    { label: '+31', value: '+31' },
    { label: '+32', value: '+32' },
    { label: '+33', value: '+33' },
    { label: '+34', value: '+34' },
    { label: '+36', value: '+36' },
    { label: '+39', value: '+39' },
    { label: '+40', value: '+40' },
    { label: '+41', value: '+41' },
    { label: '+43', value: '+43' },
    { label: '+44', value: '+44' },
    { label: '+45', value: '+45' },
    { label: '+46', value: '+46' },
    { label: '+47', value: '+47' },
    { label: '+48', value: '+48' },
    { label: '+49', value: '+49' },
    { label: '+51', value: '+51' },
    { label: '+52', value: '+52' },
    { label: '+53', value: '+53' },
    { label: '+54', value: '+54' },
    { label: '+55', value: '+55' },
    { label: '+56', value: '+56' },
    { label: '+57', value: '+57' },
    { label: '+58', value: '+58' },
    { label: '+60', value: '+60' },
    { label: '+61', value: '+61' },
    { label: '+62', value: '+62' },
    { label: '+63', value: '+63' },
    { label: '+64', value: '+64' },
    { label: '+65', value: '+65' },
    { label: '+66', value: '+66' },
    { label: '+81', value: '+81' },
    { label: '+82', value: '+82' },
    { label: '+84', value: '+84' },
    { label: '+86', value: '+86' },
    { label: '+90', value: '+90' },
    { label: '+91', value: '+91' },
    { label: '+92', value: '+92' },
    { label: '+93', value: '+93' },
    { label: '+94', value: '+94' },
    { label: '+95', value: '+95' },
    { label: '+98', value: '+98' },
    { label: '+212', value: '+212' },
    { label: '+213', value: '+213' },
    { label: '+216', value: '+216' },
    { label: '+218', value: '+218' },
    { label: '+220', value: '+220' },
    { label: '+221', value: '+221' },
    { label: '+222', value: '+222' },
    { label: '+223', value: '+223' },
    { label: '+224', value: '+224' },
    { label: '+225', value: '+225' },
    { label: '+226', value: '+226' },
    { label: '+227', value: '+227' },
    { label: '+228', value: '+228' },
    { label: '+229', value: '+229' },
    { label: '+230', value: '+230' },
    { label: '+231', value: '+231' },
    { label: '+232', value: '+232' },
    { label: '+233', value: '+233' },
    { label: '+234', value: '+234' },
    { label: '+235', value: '+235' },
    { label: '+236', value: '+236' },
    { label: '+237', value: '+237' },
    { label: '+238', value: '+238' },
    { label: '+239', value: '+239' },
    { label: '+240', value: '+240' },
    { label: '+241', value: '+241' },
    { label: '+242', value: '+242' },
    { label: '+243', value: '+243' },
    { label: '+244', value: '+244' },
    { label: '+245', value: '+245' },
    { label: '+248', value: '+248' },
    { label: '+249', value: '+249' },
    { label: '+250', value: '+250' },
    { label: '+251', value: '+251' },
    { label: '+252', value: '+252' },
    { label: '+253', value: '+253' },
    { label: '+254', value: '+254' },
    { label: '+255', value: '+255' },
    { label: '+256', value: '+256' },
    { label: '+257', value: '+257' },
    { label: '+258', value: '+258' },
    { label: '+260', value: '+260' },
    { label: '+261', value: '+261' },
    { label: '+262', value: '+262' },
    { label: '+263', value: '+263' },
    { label: '+264', value: '+264' },
    { label: '+265', value: '+265' },
    { label: '+266', value: '+266' },
    { label: '+267', value: '+267' },
    { label: '+268', value: '+268' },
    { label: '+269', value: '+269' },
    { label: '+290', value: '+290' },
    { label: '+291', value: '+291' },
    { label: '+297', value: '+297' },
    { label: '+298', value: '+298' },
    { label: '+299', value: '+299' },
    { label: '+350', value: '+350' },
    { label: '+351', value: '+351' },
    { label: '+352', value: '+352' },
    { label: '+353', value: '+353' },
    { label: '+355', value: '+355' },
    { label: '+356', value: '+356' },
    { label: '+357', value: '+357' },
    { label: '+358', value: '+358' },
    { label: '+359', value: '+359' },
    { label: '+370', value: '+370' },
    { label: '+371', value: '+371' },
    { label: '+372', value: '+372' },
    { label: '+373', value: '+373' },
    { label: '+374', value: '+374' },
    { label: '+375', value: '+375' },
    { label: '+376', value: '+376' },
    { label: '+377', value: '+377' },
    { label: '+378', value: '+378' },
    { label: '+380', value: '+380' },
    { label: '+381', value: '+381' },
    { label: '+382', value: '+382' },
    { label: '+385', value: '+385' },
    { label: '+386', value: '+386' },
    { label: '+387', value: '+387' },
    { label: '+389', value: '+389' },
    { label: '+420', value: '+420' },
    { label: '+421', value: '+421' },
    { label: '+423', value: '+423' },
    { label: '+500', value: '+500' },
    { label: '+501', value: '+501' },
    { label: '+502', value: '+502' },
    { label: '+503', value: '+503' },
    { label: '+504', value: '+504' },
    { label: '+505', value: '+505' },
    { label: '+506', value: '+506' },
    { label: '+507', value: '+507' },
    { label: '+508', value: '+508' },
    { label: '+509', value: '+509' },
    { label: '+590', value: '+590' },
    { label: '+591', value: '+591' },
    { label: '+592', value: '+592' },
    { label: '+593', value: '+593' },
    { label: '+595', value: '+595' },
    { label: '+597', value: '+597' },
    { label: '+598', value: '+598' },
    { label: '+670', value: '+670' },
    { label: '+672', value: '+672' },
    { label: '+673', value: '+673' },
    { label: '+674', value: '+674' },
    { label: '+675', value: '+675' },
    { label: '+676', value: '+676' },
    { label: '+677', value: '+677' },
    { label: '+678', value: '+678' },
    { label: '+679', value: '+679' },
    { label: '+680', value: '+680' },
    { label: '+681', value: '+681' },
    { label: '+682', value: '+682' },
    { label: '+683', value: '+683' },
    { label: '+685', value: '+685' },
    { label: '+686', value: '+686' },
    { label: '+687', value: '+687' },
    { label: '+688', value: '+688' },
    { label: '+689', value: '+689' },
    { label: '+690', value: '+690' },
    { label: '+691', value: '+691' },
    { label: '+692', value: '+692' },
    { label: '+850', value: '+850' },
    { label: '+852', value: '+852' },
    { label: '+853', value: '+853' },
    { label: '+855', value: '+855' },
    { label: '+856', value: '+856' },
    { label: '+870', value: '+870' },
    { label: '+880', value: '+880' },
    { label: '+886', value: '+886' },
    { label: '+960', value: '+960' },
    { label: '+961', value: '+961' },
    { label: '+962', value: '+962' },
    { label: '+963', value: '+963' },
    { label: '+964', value: '+964' },
    { label: '+965', value: '+965' },
    { label: '+966', value: '+966' },
    { label: '+967', value: '+967' },
    { label: '+968', value: '+968' },
    { label: '+971', value: '+971' },
    { label: '+972', value: '+972' },
    { label: '+973', value: '+973' },
    { label: '+974', value: '+974' },
    { label: '+975', value: '+975' },
    { label: '+976', value: '+976' },
    { label: '+977', value: '+977' },
    { label: '+992', value: '+992' },
    { label: '+993', value: '+993' },
    { label: '+994', value: '+994' },
    { label: '+995', value: '+995' },
    { label: '+996', value: '+996' },
    { label: '+998', value: '+998' }
  ];

  public static CARS_ICONS = [
    { class: 'car-icon-0', value: '' },
    { class: 'car-icon-1', value: '1' },
    { class: 'car-icon-2', value: '2' },
    { class: 'car-icon-3', value: '3' },
    { class: 'car-icon-4', value: '4' },
    { class: 'car-icon-5', value: '5' },
    { class: 'car-icon-6', value: '6' },
    { class: 'car-icon-7', value: '7' },
    { class: 'car-icon-8', value: '8' },
    { class: 'car-icon-9', value: '9' },
    { class: 'car-icon-10', value: '10' },
    { class: 'car-icon-11', value: '11' },
    { class: 'car-icon-12', value: '12' },
    { class: 'car-icon-13', value: '13' },
    { class: 'car-icon-14', value: '14' },
    { class: 'car-icon-15', value: '15' },
    { class: 'car-icon-16', value: '16' },
    { class: 'car-icon-17', value: '17' },
    { class: 'car-icon-18', value: '18' },
    { class: 'car-icon-19', value: '19' },
    { class: 'car-icon-20', value: '20' },
    { class: 'car-icon-21', value: '21' },
    { class: 'car-icon-22', value: '22' },
    { class: 'car-icon-23', value: '23' },
    { class: 'car-icon-24', value: '24' },
    { class: 'car-icon-25', value: '25' },
    { class: 'car-icon-26', value: '26' },

  ];


  public static LOGGED_IN_ROLE = '';
  public static ADMINROLEID = 'Tenant Admin';
  public static DISPATCHERROLEID = 'Dispatcher Admin';
  public static CORPORATEROLEID = 'Corporate Admin';
  public static HOTELBOOKINGROLECODE = 'Hotel Booking';
  public static CORPORATEBOOKINGROLECODE = 'Corporate Booking';
  public static EMPLOYEE_ID = '';
  public static DEPARTMENT_ID = '';

  public static SALES_QUOTATION_TRIP_STATUS = [
    {
      label: 'Select',
      value: ''
    }, {
      label: 'New Request',
      value: 'NEW_REQUEST'
    }, {
      label: 'Quote Sent',
      value: 'QUOTE_SENT'
    }, {
      label: 'Quote Rejected',
      value: 'QUOTE_REJECTED'
    }, {
      label: 'Quote Accepted',
      value: 'QUOTE_ACCEPTED'
    }, {
      label: 'Cancelled',
      value: 'CANCELED'
    }
  ];

  public static BOOKING_DRIVER_ASSIGNED_STATUS = [20, 90, 70, 80, 40, 130, 120, 170, 50, 140, 150, 160, 100];



  public static RENTAL_SERVICE_TYPE = [
    'Rental with driver with fuel',
    'Rental without driver without fuel',
    'Rental with driver without fuel',
    'Rental without driver with fuel',
    'Chauffeur'
  ];

  public static ASSIGN_BOOKING_STATUS_ARRAY = [10];
  public static DRIVER_IS_ARRIVED = [90];
  public static BOOOKING_QUOTATION_ACCEPTED = [30];
  public static REASSIGN_BOOKING_STATUS_ARRAY = [80, 40, 41];
  public static COMPLETE_BOOKING_STATUS_ARRAY = [130, 120, 170, 50];
  public static DRIVER_ON_THE_WAY = [80];
  public static SECURITY_CHECK = [100];
  public static END_TRIP = [110];
  public static CAR_RETURN_CHECK = [140];
  public static RETURN_SECURITY_CHECK = [150];
  public static ON_TRIP = [130];

  public static BOOKING_DETAILS_STATUS_DISABLE_ARRAY = [
    120, 170, 50, 30
  ];

  public static BOOKING_STATUS = {
    END_TRIP: 140,
    CANCELED: 120,
    EXPIRED: 71,
  }




  public static TRANSMISSION_TYPE = [
    {
      label: 'Please select',
      value: ''
    },
    {
      label: 'Both (Automatic/Manual)',
      value: 'BOTH'
    },
    {
      label: 'Automatic',
      value: 'AUTO'
    },
    {
      label: 'Manual',
      value: 'MANL'
    }
  ];

  public static HOTEL_PRICING_LINK = 'pricing-packages-details';
  public static HOTEL_ROUTE_LINK = 'route-pricing-details';
  public static HOTEL_Profile_image = '/assets/images/temp/default_hotel.png';
  public static NOTIFICATION_INTERVAL = 60 * 1000; // 1 min
  public static LIVE_DASHBOARD_REFRESH_INTERVAL = 30 * 1000; // 30 sec


  public static MAP_OPTION = {
    center: {
      lat: 18.5971, lng: 73.7188
    },
    zoom: 11,
    zoomControl: false
  };

  public static SERVICE_TYPE_RENTAL = 'Rental';
  public static SERVICE_TYPE_TAXI = 'Taxi';
  public static SERVICE_TYPE_OCCASIONAL = 'Occasional Ride';

  public static DATE_FORMATTER = 'MMM DD, YYYY hh:mm A';

  public static PASSENGER_TYPES = [
    {
      label: 'Private',
      value: 'Private'
    }, {
      label: 'Corporate',
      value: 'corporate'
    }
  ];

  public static PASSENGER_TYPES_MANUAL_BOOKING = [
    { label: 'Please Select', value: '' },
    { label: 'Guest Users', value: 'guestPassenger' },
    { label: 'App Users', value: 'appPassenger' }
  ];

  public static DRIVER_TYPES_MANUAL_BOOKING = [
    { label: 'Please Select', value: '' },
    { label: 'Select Manually', value: 'selectDriver' },
    { label: 'Auto Dispatch', value: 'automatic' },

  ];

  public static twentyThreeFiftyNineLapse = 86399000;

  public static IGNORE_LINK = ['edit-corporate', 'corporate-details', 'hotel-details', 'reports', 'settings', 'bookings', 'passengers', 'drivers', 'vehicles', 'manage-cities', 'manage-users'
    , 'user-management', 'manage-roles', 'about-company',
     'app-settings', 'marketing', 'notifications','FAQs',
     'terms-and-conditions', 'privacy-policy', 'rental-policy',
      'chauffeur-policy', 'promo-code', 'promo-code-details', 'segments','settings','manage-taxes','vehicle-type'
    ,'reports','driver-login-logout','driver-login-logout-details','driver-duty','driver-duty-details',
    'driver-mileage','driver-mileage-details','referral-credit','referral-credit-details','passenger-feedback',
    'passenger-feedback-details','driver-income','driver-income-details','refund-reports','passenger-bookings',
    'passenger-bookings-details','passenger-wallet-booking','wallet-transactions','passenger-wallet','driver-feedback',
    'driver-performance','driver-performance-details','car-mileage','car-mileage-details','transaction','transaction-details',
    'refund','charge-code','charge-code-details','driver-referral-credit','driver-referral-credit-details','referral-credit',
    'referral-credit-details','passenger-feedback','passenger-feedback-details','driver-income','driver-income-details',
    'refund-reports','passenger-bookings','passenger-bookings-details','passenger-wallet-booking','wallet-transactions',
    'passenger-wallet','driver-feedback-details','driver-performance','driver-performance-details','car-mileage',
    'car-mileage-details','transaction','transaction-details','refund','charge-code','charge-code-details',
    'driver-referral-credit','driver-referral-credit-details','referral-credit','referral-credit-details','manual-booking-v1','manual-booking','add-vehicle-info', 'add-passenger'];

  public static FILE_UPLOAD_MAX_SIZE_IN_BYTE = 10000000;

  public static SECURITY_CHECK_TYPE = {
    security: 'SECURITY_CHECK',
    delivery: 'DELIVERY_CHECK',
    carReturn: 'CAR_RETURN_CHECK',
    returnSecurity: 'RETURN_SECURITY_CHECK',
  };

  public static PAYMENT_MODE = [{
    label: 'Cash',
    value: 'CASH'
  }];
  public static ADMIN_RESET_PASSWORD = 'admin_reset_password';
  public static PAYMENT_GATEWAY = 'payment_gateway'
  public static PAYMENT_GATEWAY_WING = 'WING'
  public static PAYMENT_TYPES = 'payment_types'
  public static DEFAULT_MAP_ROUTE_COLOR = '#3B7BFF';
  public static DEFAULT_ROUTE_COLOR = '#000000';
  public static IS_OCCASIONAL_TRIP = 'occasional_trip';
  public static IS_ACTUAL_SURGE = 'actual_surge';
  public static IS_CAPTURE_ACTIVITY_LOGS = 'capture_activity_logs';
  public static HEADER_NOT_REQUIRED = ['/sign-in', '/trackmylocation', '/'];
  public static ENTER_KEY = 13;
  public static ACTIVATE = 'Activate';
  public static DEACTIVATE = 'Deactivate';
  public static MAX_RATING = ['1', '2', '3', '4', '5'];
  public static THIRD_PARTY_UERV_ERIFICATION = 'third_party_user_verification'



  public static VEHICLES_STATUS = [
    { label: 'All', value: '' },
    { label: 'Available', value: 'Available' },
    { label: 'Busy', value: 'Busy' }
  ];

  public static DRIVER_ASSIGNED_OPTIONS = [
    { label: 'Please select', value: '' },
    { label: 'Assigned', value: 'assigned' },
    { label: 'Unassigned', value: 'nonAssigned' }
  ];

  public static DRIVER_STATUS = [
    { label: 'All', value: '' },
    { label: 'Available', value: 'Available' },
    { label: 'Busy', value: 'Busy' },
    { label: 'Offline', value: 'Offline' }
  ];

  public static RIDE_SHARE_OPTIONS = [
    { label: 'Please select', value: '' },
    { label: 'On', value: true },
    { label: 'Off', value: false }
  ];



  public static ERROR_MESSAGE = 'error';
  public static SUCCESS_MESSAGE = 'success';
  public static INFO_MESSAGE = 'info';
  public static WARN_MESSAGE = 'warn';
  public static WARN_MESSAGE_ACTIVE_DECTIVE_VEHICLE = 'Are you sure you want to STATUS_LABEL this vehicle?';
  public static WARN_MESSAGE_ACTIVE_DECTIVE_USER = 'Are you sure you want to STATUS_LABEL this user?';
  public static WARN_MESSAGE_ACTIVE_DECTIVE_ROLE = 'Are you sure you want to STATUS_LABEL this role?';


  public static STATUS_ACTIVE_DEACTIVE = [
    { label: 'All', value: '' },
    { label: 'Actived', value: true },
    { label: 'Deactivated', value: false }
  ];

  public static GENDER_OPTION = [
    { label: 'Please select', value: '' },
    { label: 'Male', value: 'M' },
    { label: 'Female', value: 'F' }
  ];


  public static NEW_REQUEST_BOOKING_STATUS = 10;
  public static DRIVER_ASSIGNED_BOOKING_STATUS = 40;
  public static ACCEPTED_BOOKING_STATUS = 41;
  public static DRIVER_ON_THE_WAY_BOOKING_STATUS = 80;
  public static DRIVER_ARRIVED_BOOKING_STATUS = 90;
  public static ON_TRIP_BOOKING_STATUS = 130;
  public static COMPLETED_BOOKING_STATUS = 140;
  public static EXPIRED_BOOKING_STATUS = 71;
  public static CANCELLED_BOOKING_STATUS = 120;

  public static IS_ADD_PASSENGER_BY_ADMIN = 'add_passenger_by_admin';
  public static IS_TIP_APPLICABLE = 'is_tip_applicable';
  public static IS_EDIT_PASSENGER_BY_ADMIN = 'edit_passenger_by_admin';
  public static IS_DRIVER_IDOLOGY_VERIFICATION = 'third_party_user_verification';
  public static CAPITAL_ALPHA_NUMERIC = new RegExp(['^[A-Za-z0-9]*$'].join(''));
  public static DRIVER_DESTINATION_ACTIVATION_COUNT = 'driver_destination_activation_count';
  public static PREFERRED_DESTINATION = 'preferred_destination';
  public static GDPR_COMPLIANCE = 'gdpr_compliance';


  public static DRIVER_STATUS_FILTER_OPTIONS = [
    { label: 'All', value: '' },
    { label: 'Available', value: 'Available' },
    { label: 'Busy', value: 'Busy' },
    { label: 'Idle', value: 'Idle' },
    { label: 'Offline', value: 'Offline' }
  ];

  public static RIDE_TYPE_OPTIONS = [
    {
      label: 'All',
      value: ''
    },
    {
      label: 'Ride Now',
      value: '1'
    },
    {
      label: 'Ride Later',
      value: '2'
    },
    {
      label: 'Ride Share',
      value: '3'
    }
  ];

  public static BOOKING_TYPE_OPTIONS = [
    {
      label: 'All',
      value: ''
    },
    {
      label: 'Corporate',
      value: 'CORPORATE'
    },
    {
      label: 'Individual',
      value: 'INDIVIDUAL'
    }
  ];

  public static RIDE_TYPE_WITHOUT_RIDE_SHARE_OPTIONS = [
    {
      label: 'All',
      value: ''
    },
    {
      label: 'Ride Now',
      value: '1'
    },
    {
      label: 'Ride Later',
      value: '2'
    }
  ];

  public static STATUS_OPTIONS = [{
    label: 'All',
    value: ''
  }, {
    label: 'Active',
    value: true
  }, {
    label: 'Deactivated',
    value: false
  }];

  public static FILTERED_STATUS_OPTIONS = [{
    label: 'All',
    value: ''
  }, {
    label: 'Active',
    value: 'true'
  }, {
    label: 'Deactivated',
    value: 'false'
  }];

  public static FILE_EXPORT_DAYS_LIMIT_COUNT = 'file_export_days_limit_count';

  public static SEVERITY = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
    WARN: 'warn'
  };

  public static SUMMERY = {
    SUCCESS: 'Success',
    ERROR: 'Error',
    INFO: 'Info',
    WARN: 'Warn',
    CONFIRMED: 'Confirmed',
    REJECTED: 'Rejected'
  };

  public static DRIVER_STATUS_OPTIONS = [
    {
      label: 'All',
      value: ''
    },
    {
      label: 'Available',
      value: 'Available'
    },
    {
      label: 'Busy',
      value: 'Busy'
    },
    {
      label: 'Offline',
      value: 'Offline'
    },
    {
      label: 'Idle',
      value: 'Idle'
    }];

  public static PROMO_CODE_OPTIONS = [
    {
      label: 'All',
      value: ''
    },
    {
      label: 'Active',
      value: 'Active'
    },
    {
      label: 'Deactivated',
      value: 'Deactivated'
    },
    {
      label: 'Expired',
      value: 'Expired'
    }
  ];

  
  public static PLATFORM_OPTIONS = [
    { label: 'Android', value: 'android'},
    { label: 'iOS', value: 'ios'},
    { label: 'Web', value: 'web'},
  ]

  public static APP_OPTIONS = [
    { label: 'Passenger', value: 'passenger'},
    { label: 'Driver', value: 'driver'},
    { label: 'Admin', value: 'admin'},
  ]
  public static VERSION_NUMBER = /^[0-9.]+$/;

    public static MESSAGE_TYPE = {
    SUCCESS: "success",
    ERROR: "error",
    CONFIRMED: "Confirmed",
    WARNING: "warning",
    INFO: "info",
  };
  public static DATE_TIME_FORMAT_MOMENT = "HH:mm, DD MMM YYYY";
  public static DEFAULT_TIME_FORMATE = "HH:mm";
  public static TIME_FORMAT_RECORD = 'timeFormatRecord';
  public static DATE_ONLY_FORMATE = "DD MMM YYYY";  
  public static ADD_UPDATE_NEW_VERSION_FLAG = 'add_update_new_version_flag';  
  public static WEB_VERSION = "web_app_version_for_display";

    //Google Route
  public static strokeColor = "#0094ff";
  public static strokeOpacity = 1.0;
  public static strokeWeight = 4;


  public static SAVE_FILTERS = 'Filters';
  public static FILTER_SCREEN_CODE = {
    BOOKING_LIST_SCREEN: 'bookings_screen',
    PASSENGER_LIST_SCREEN: 'passengers_screen',
    DRIVER_LIST_SCREEN: 'drivers_screen',
    VEHICLE_LIST_SCREEN: 'vehicles_screen',
    CITY_LIST_SCREEN: 'city_screen',
    ROLE_LIST_SCREEN: 'roles_screen',
    USER_LIST_SCREEN: 'users_screen',
    SERVICE_DOWN_TIME_SCREEN: 'service_down_time_screen'
  };

    public static REBOOK_BUTTON_STATUS = [140,71,120];

    public static LANGUAGE_LABELS = {
      'en': 'English',
      'es': 'Spanish',
      'fr': 'French',
      'de': 'German',
      'it': 'Italian',
      'pt': 'Portuguese',
      'ru': 'Russian',
    };  

  public static DATE_RANGE_IN_DAYS = 90;


  
  public static APPROVAL_STATUS_COLLECTION_MULTISELECT_FILTER = [
    { label: 'Accepted', value: '1' },
    { label: 'Rejected', value: '2' },
    { label: 'Pending', value: '0' },
    { label: 'Not Needed', value: '-1' }
  ];

  public static BOOKING_TYPE_MULTISELECT_FILTER = [
    { label: 'Corporate', value: 'CORPORATE' },
    { label: 'Individual', value: 'INDIVIDUAL' }
  ];

  
  public static BOOKING_STATUS_CODES_FILTER_OPTIONS = [
    // { label: 'All', value: '' },
    { label: 'New Request', value: 10 },
    { label: 'Driver Assigned', value: 40 },
    // { label: 'Rejected', value: 50 },
    // { label: 'Timed Out', value: 60 },
    // { label: 'Regret', value: 70 },
    { label: 'Driver On The Way', value: 80 },
    { label: 'Driver Arrived', value: 90 },
    { label: 'Cancelled', value: 120 },
    { label: 'On Trip', value: 130 },
    { label: 'Trip Ended', value: 140 },
    { label: 'Completed', value: 170 },
  ];

  
  public static BOOKING_STATUS_LATEST = [
    //   {
    //   label: 'All',
    //   value: ''
    // },
    {
      label: 'New Request',
      value: 10
    }, {
      label: 'Driver Assigned',
      value: 40
    }, {
      label: 'Rejected',
      value: 50
    }, {
      label: 'Timed Out',
      value: 60
    }, {
      label: 'Regret',
      value: 70
    }, {
      label: 'Driver On The Way',
      value: 80
    }, {
      label: 'Driver Arrived',
      value: 90
    }, {
      label: 'Cancelled',
      value: 120
    }, {
      label: 'On Trip',
      value: 130
    }, {
      label: 'Trip Ended',
      value: 140
    }, {
      label: 'Completed',
      value: 170
    }
    ];

    

    public static VEHICLES_DISPATCH_DASHBOARD_DATA = {
      "unassignedTourList": [
        {
          "tripId": "304f8b023fb743da9a8d2ec9c5816992",
          "driverId": null,
          "vehicleId": null,
          "tourStatus": 10,
          "pickupDateTime": 1779180646652,
          "pickupDateTimeForDisplay": 1779180646652,
          "estimatedTourEndDateTime": 1779181846652,
          "etaForDisplay": 1200000,
          "cardColorCode": "#cdbeff",
          "pickupDateTimeStr": "05/19/2026 14:20:46",
          "pickupDateTimeForDisplayStr": "05/19/2026 14:20:46",
          "estimatedTourEndDateTimeStr": "05/19/2026 14:40:46",
          "etaForDisplayStr": "20 Mins",
          "passengerName": "Yogesh Test",
          "pickupLocationName": "Baner, Pune, Maharashtra, India",
          "dropLocationName": "Ravet, Pimpri-Chinchwad, Maharashtra, India",
          "bookingType": "Private",
          "corporateName": null,
          "bookingFor": "Myself",
          "bookingForEmail": "",
          "bookingForName": "",
          "bookingForNumCountryCode": "",
          "bookingForPhoneNum": "",
          "vip": false,
          "bookingStatus": 10,
          "bookingCode": "B110219",
          "bookingStatusStr": "New Request",
          "eta": 1200000,
          "travelReason": "",
          "chargeCode": "",
          "note": "Testing",
          "stopLocationList": []
        },
        {
          "tripId": "363a20b43aa94dc0b6932b1fa7f911d3",
          "driverId": null,
          "vehicleId": null,
          "tourStatus": 10,
          "pickupDateTime": 1779187814149,
          "pickupDateTimeForDisplay": 1779187814149,
          "estimatedTourEndDateTime": 1779191174149,
          "etaForDisplay": 3360000,
          "cardColorCode": "#cdbeff",
          "pickupDateTimeStr": "05/19/2026 16:20:14",
          "pickupDateTimeForDisplayStr": "05/19/2026 16:20:14",
          "estimatedTourEndDateTimeStr": "05/19/2026 17:16:14",
          "etaForDisplayStr": "56 Mins",
          "passengerName": "Employee Fourty",
          "pickupLocationName": "Wakad, Pimpri-Chinchwad, Maharashtra, India",
          "dropLocationName": "Katraj, Pune, Maharashtra, India",
          "bookingType": "Corporate",
          "corporateName": "Mobi Testing",
          "bookingFor": "Myself",
          "bookingForEmail": "",
          "bookingForName": "",
          "bookingForNumCountryCode": "",
          "bookingForPhoneNum": "",
          "vip": false,
          "bookingStatus": 10,
          "bookingCode": "B110220",
          "bookingStatusStr": "New Request",
          "eta": 3360000,
          "travelReason": "Office meeting",
          "chargeCode": "test",
          "note": "Test",
          "stopLocationList": [
            {
              "id": null,
              "createdAt": 0,
              "updatedAt": 0,
              "bookingId": "363a20b43aa94dc0b6932b1fa7f911d3",
              "latitude": 18.4864727,
              "longitude": 73.79683399999999,
              "dropLocation": null,
              "dropAddress": "Warje, Pune, Maharashtra, India",
              "index": 1
            }
          ]
        },
        {
          "tripId": "8070dfd0f22947988e5e52fc4092cc57",
          "driverId": null,
          "vehicleId": null,
          "tourStatus": 10,
          "pickupDateTime": 1779199253301,
          "pickupDateTimeForDisplay": 1779199253301,
          "estimatedTourEndDateTime": 1779200513301,
          "etaForDisplay": 1260000,
          "cardColorCode": "#cdbeff",
          "pickupDateTimeStr": "05/19/2026 19:30:53",
          "pickupDateTimeForDisplayStr": "05/19/2026 19:30:53",
          "estimatedTourEndDateTimeStr": "05/19/2026 19:51:53",
          "etaForDisplayStr": "21 Mins",
          "passengerName": "Employee Fourty",
          "pickupLocationName": "Ravet, Pimpri-Chinchwad, Maharashtra, India",
          "dropLocationName": "Baner, Pune, Maharashtra, India",
          "bookingType": "Private",
          "corporateName": "Mobi Testing",
          "bookingFor": "Myself",
          "bookingForEmail": "",
          "bookingForName": "",
          "bookingForNumCountryCode": "",
          "bookingForPhoneNum": "",
          "vip": false,
          "bookingStatus": 10,
          "bookingCode": "B110221",
          "bookingStatusStr": "New Request",
          "eta": 1260000,
          "travelReason": null,
          "chargeCode": null,
          "note": "test",
          "stopLocationList": []
        }
      ],
      "vehicleDetailsList": null,
      "driverDetailsList": [
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "79c844f6eafe4a1ebbd3ed199a65ad30",
          "driverFirstName": "Mobi",
          "driverLastName": "testing",
          "driverCode": "DRI24400",
          "driverPhoneNum": "2211221122",
          "driverEmail": "t1222@mipltest.in",
          "driverProfileImage": "1502d62d1da74b638010f7e34b318910.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "9de91ac2358840008cd2582337cda394",
          "vehicleCode": "MH12AB1122",
          "vehicleRegistration": "MH12AB1122",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Hyundai",
          "modelName": "i 20",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "1",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [
            {
              "tripId": "34e6c6769a874843b5320d8277bae833",
              "driverId": "79c844f6eafe4a1ebbd3ed199a65ad30",
              "vehicleId": "9de91ac2358840008cd2582337cda394",
              "tourStatus": 40,
              "pickupDateTime": 1779184832468,
              "pickupDateTimeForDisplay": 1779184832468,
              "estimatedTourEndDateTime": 1779185672468,
              "etaForDisplay": 840000,
              "cardColorCode": "#aae1ff",
              "pickupDateTimeStr": "05/19/2026 15:30:32",
              "pickupDateTimeForDisplayStr": "05/19/2026 15:30:32",
              "estimatedTourEndDateTimeStr": "05/19/2026 15:44:32",
              "etaForDisplayStr": "14 Mins",
              "passengerName": "Yogesh Passenger",
              "pickupLocationName": "Baner, Pune, Maharashtra, India",
              "dropLocationName": "Hinjewadi, Pune, Maharashtra, India",
              "bookingType": "Corporate",
              "corporateName": "Mobi Testing",
              "bookingFor": "Myself",
              "bookingForEmail": "",
              "bookingForName": "",
              "bookingForNumCountryCode": "",
              "bookingForPhoneNum": "",
              "vip": false,
              "bookingStatus": 40,
              "bookingCode": "B110222",
              "bookingStatusStr": "Driver Assigned",
              "eta": 840000,
              "travelReason": "training",
              "chargeCode": "test",
              "note": "Test",
              "stopLocationList": []
            }
          ],
          "bookingCount": 1
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "ffad6782767d45b19e73cc091d99db40",
          "driverFirstName": "Qtsfii",
          "driverLastName": "Automation",
          "driverCode": "DRI25813",
          "driverPhoneNum": "4586935152",
          "driverEmail": "t196@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "0ab424d66b224740800db3203edf66f4",
          "vehicleCode": "1111",
          "vehicleRegistration": "1111",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "dev1",
          "modelName": "tata",
          "capacity": 6,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "fc83693920154041a04a938319a75615",
          "driverFirstName": "John",
          "driverLastName": "",
          "driverCode": "DRI24518",
          "driverPhoneNum": "2211445555",
          "driverEmail": "t222@mipltest.in",
          "driverProfileImage": "38df1c038de84b8daaccd275cd543f39.png",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Wednesday",
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": "12",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "fb80219ee94c4325913c4968395afc62",
          "driverFirstName": "Vjujgo",
          "driverLastName": "Sxorbr - Automation",
          "driverCode": "DRI24090",
          "driverPhoneNum": "7418856321",
          "driverEmail": "t9773@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "WEDNESDAY",
          "vehicleId": "840be27c5056404f9848480280ca8e4c",
          "vehicleCode": "IU99 LH9844",
          "vehicleRegistration": "IU99 LH9844",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Audi",
          "modelName": "Mustang",
          "capacity": 2,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "f841697d9a3c493a987ed9ba09ffaba1",
          "driverFirstName": "Ujicdp",
          "driverLastName": "OfyqlzAutomation",
          "driverCode": "DRI14566",
          "driverPhoneNum": "2717935419",
          "driverEmail": "t4945@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "f66d8e434db24f91aa48e7dd8908aa13",
          "driverFirstName": "Allen",
          "driverLastName": null,
          "driverCode": "DRI25006",
          "driverPhoneNum": "98989899",
          "driverEmail": "t107@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": true,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "ebf4f25781f44c238554046064d9b5f3",
          "driverFirstName": "James",
          "driverLastName": "Test",
          "driverCode": "DRI27083",
          "driverPhoneNum": "2332233223",
          "driverEmail": "t401@mipltest.in",
          "driverProfileImage": "abc74e880f53460798119c38c832817a.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "f0dc120e0a364dcf833d7fe342f3e2ef",
          "vehicleCode": "MG63 LK4899",
          "vehicleRegistration": "MG63 LK4899",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Ford",
          "modelName": "X5",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "ebdea65a007b41c1b196ad3ec6ba153c",
          "driverFirstName": "Joseph",
          "driverLastName": "Driver",
          "driverCode": "DRI27259",
          "driverPhoneNum": "2332233200",
          "driverEmail": "t859@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "ef360a80230d439f89571d3485d9ab73",
          "vehicleCode": "MH12 MO3456",
          "vehicleRegistration": "MH12 MO3456",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "KIA",
          "modelName": "SELTOS",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "e9991aee2688451c87321ff93b8fc43a",
          "driverFirstName": "Nvtben",
          "driverLastName": "FzlezaAutomation",
          "driverCode": "DRI16736",
          "driverPhoneNum": "9223284575",
          "driverEmail": "t3809@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "e6f3d9d07fcd4d62a267b3734c2708d2",
          "driverFirstName": "Nilesh",
          "driverLastName": "Driver",
          "driverCode": "DRI12048",
          "driverPhoneNum": "8080915126",
          "driverEmail": "t112@mipltest.in",
          "driverProfileImage": "6b9c8233d78442d9911e083fd9a9bf6c.jpg",
          "dutyStatus": true,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Tuesday",
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": 1779129000000,
          "weekOffEnd": 1779215399999,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [
            {
              "slotFromDateTime": 1779129000000,
              "slotToDateTime": 1779215399999,
              "slotFromDateTimeStr": "05/19/2026 00:00:00",
              "slotToDateTimeStr": "05/19/2026 23:59:59",
              "shiftType": "16",
              "periodType": "weekOff"
            }
          ],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "e6c3e8dac37943b7a232b1c5097fa78b",
          "driverFirstName": "Dev",
          "driverLastName": "Driver35",
          "driverCode": "DRI22132",
          "driverPhoneNum": "888888888",
          "driverEmail": "t35@mipltest.in",
          "driverProfileImage": "6b9c8233d78442d9911e083fd9a9bf6c.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "e1084fed445044edaf53d894fb69993e",
          "driverFirstName": "Robert",
          "driverLastName": null,
          "driverCode": "DRI15822",
          "driverPhoneNum": "0004334231",
          "driverEmail": "t857@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "e4b65b1d401242a7a948ee2377804fe6",
          "vehicleCode": "MH12 MO0012",
          "vehicleRegistration": "MH12 MO0012",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "MARUTI",
          "modelName": "ERTIGA",
          "capacity": 7,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "decea0069cd94f3cb3a7d5080d3bdd88",
          "driverFirstName": "Mark",
          "driverLastName": "Henry",
          "driverCode": "DRI13269",
          "driverPhoneNum": "9874563210",
          "driverEmail": "saurabh.agrawal@mobisoftinfotech.com",
          "driverProfileImage": "6b9c8233d78442d9911e083fd9a9bf6c.jpg",
          "dutyStatus": true,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": "27e5d06f14eb4a5692b33813cec06b37",
          "vehicleCode": "545454",
          "vehicleRegistration": "545454",
          "vehicleType": "Voxy 6 Pax",
          "vehicleTypeIconName": null,
          "makeModel": "Test",
          "modelName": "Test",
          "capacity": 44,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "d692824969d342be92c6fd77d4d6f6ea",
          "driverFirstName": "bhaskar",
          "driverLastName": "",
          "driverCode": "DRI11498",
          "driverPhoneNum": "9819146328",
          "driverEmail": "bhaskarawasare804@gmail.com",
          "driverProfileImage": "5a68689e18f44700a1628beb2c3e6cae.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "e64f17c0728e43eab53abdbd8fad2603",
          "vehicleCode": "MH 12 YB 2233",
          "vehicleRegistration": "MH 12 YB 2233",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Kia",
          "modelName": "Seltos",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "d3674c2979124e9e925893929513e6d9",
          "driverFirstName": "Huncnq",
          "driverLastName": "WbknqbAutomation",
          "driverCode": "DRI23306",
          "driverPhoneNum": "6612848198",
          "driverEmail": "t5950@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": "76ffc1f4a1ef4b21a597a0f582cb7cb4",
          "vehicleCode": "4444",
          "vehicleRegistration": "4444",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "dev4",
          "modelName": "tata",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "d2448754407845dfb387b42d3d087c98",
          "driverFirstName": "Xvlrxh",
          "driverLastName": "Automation",
          "driverCode": "DRI29738",
          "driverPhoneNum": "1759561313",
          "driverEmail": "t5404@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Saturday",
          "vehicleId": "622dd1978c204f59b1c459baeffdaefd",
          "vehicleCode": "1111",
          "vehicleRegistration": "1111",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Maruti Suzuki",
          "modelName": "Dzire",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "cbb896f358f947e58efaf0f84c0ed369",
          "driverFirstName": "Xsmgfl",
          "driverLastName": "Vftdls - Automation",
          "driverCode": "DRI13361",
          "driverPhoneNum": "7318735178",
          "driverEmail": "t1499@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "WEDNESDAY",
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "bfe9684dd8ca4b9ea54cc64cfea8626c",
          "driverFirstName": "Dev",
          "driverLastName": "Driver36",
          "driverCode": "DRI13196",
          "driverPhoneNum": "965778002",
          "driverEmail": "t36@mipltest.in",
          "driverProfileImage": "2079498decf84245b6e86567db650783.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "bae34561838243f6ad69a3062832699c",
          "driverFirstName": "Atul",
          "driverLastName": "Driver",
          "driverCode": "DRI11934",
          "driverPhoneNum": "0002332233",
          "driverEmail": "t600@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "d3ed407232ab4d1b873f33bb71ed7de7",
          "vehicleCode": "MH17 AB9999",
          "vehicleRegistration": "MH17 AB9999",
          "vehicleType": "Voxy 6 Pax",
          "vehicleTypeIconName": null,
          "makeModel": "TATA",
          "modelName": "Safari",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "b5f1d9e36aa6493d9bd0d4b75d94c7a5",
          "driverFirstName": "Qbginq",
          "driverLastName": "Vyvwba - Automation",
          "driverCode": "DRI21445",
          "driverPhoneNum": "7398811938",
          "driverEmail": "t835@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "WEDNESDAY",
          "vehicleId": "7a04af92cec54360bb92ea6be9e736af",
          "vehicleCode": "OC37 CO8838",
          "vehicleRegistration": "OC37 CO8838",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Hyundai",
          "modelName": "Corolla",
          "capacity": 2,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "b4dbfb57f4cc441f80e023b55715f10a",
          "driverFirstName": "Jacob",
          "driverLastName": null,
          "driverCode": "DRI19142",
          "driverPhoneNum": "0000034345",
          "driverEmail": "t9033@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "61f6e4cf890e482aa2dec1ba1733b0a5",
          "vehicleCode": "MH12 ER9119",
          "vehicleRegistration": "MH12 ER9119",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "TATA",
          "modelName": "PUNCH",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "b4d8940c85b542908ea844bfd9248d00",
          "driverFirstName": "Mobisoft",
          "driverLastName": "Driver",
          "driverCode": "DRI29702",
          "driverPhoneNum": "2344321221",
          "driverEmail": "t257@mipltest.in",
          "driverProfileImage": "38df1c038de84b8daaccd275cd543f39.png",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Monday",
          "vehicleId": "24cc83bf8dfd45e6b56c6ecbe9a44bbb",
          "vehicleCode": "MH12 AB0009",
          "vehicleRegistration": "MH12 AB0009",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Mahindra",
          "modelName": "XUV 700",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "12",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "b3b1e2e3d2b14d6ba59c0653286a9623",
          "driverFirstName": "Abhijit",
          "driverLastName": "",
          "driverCode": "DRI13455",
          "driverPhoneNum": "9404283658",
          "driverEmail": "t83@mipltest.in",
          "driverProfileImage": "6b9c8233d78442d9911e083fd9a9bf6c.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Wednesday",
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "b148311b38cb4537a98561c73a9fe593",
          "driverFirstName": "Xykdnt",
          "driverLastName": "Fdoyhb - Automation",
          "driverCode": "DRI28891",
          "driverPhoneNum": "6163937177",
          "driverEmail": "t9859@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "a92058f2d9b6482b986b447e5338f439",
          "driverFirstName": "Aitvta",
          "driverLastName": "Ydgfgq - Automation",
          "driverCode": "DRI14211",
          "driverPhoneNum": "9481886638",
          "driverEmail": "t5304@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "SATURDAY",
          "vehicleId": "d577846540e443ae9a7ac35fadfb8d1f",
          "vehicleCode": "XC63 IM1173",
          "vehicleRegistration": "XC63 IM1173",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Hyundai",
          "modelName": "Corolla",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "a8d632cf0b504dfd895543c3689a6bca",
          "driverFirstName": "Dev",
          "driverLastName": "Driver31",
          "driverCode": "DRI27242",
          "driverPhoneNum": "22547444555",
          "driverEmail": "t31@mipltest.in",
          "driverProfileImage": "c47453c67ee246fea0cec02f47a87e9d.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": "8d04cc3cca834907af66319b0beb1e72",
          "vehicleCode": "88888",
          "vehicleRegistration": "88888",
          "vehicleType": "Micro Van - 2 pax",
          "vehicleTypeIconName": null,
          "makeModel": "JAGVAR",
          "modelName": "tata1",
          "capacity": 6,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "a7913376aee24b83ad021ef30e13e1d1",
          "driverFirstName": "Smith",
          "driverLastName": null,
          "driverCode": "DRI25375",
          "driverPhoneNum": "0000012212",
          "driverEmail": "t854@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "27b3ee0f9fc540a2a94841a2ed151509",
          "vehicleCode": "MH12 MO3445",
          "vehicleRegistration": "MH12 MO3445",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "MARUTI",
          "modelName": "BALENO",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "9a2064b6dd354274987ba8f597838d65",
          "driverFirstName": "Peter",
          "driverLastName": "Driver",
          "driverCode": "DRI28165",
          "driverPhoneNum": "0000012211",
          "driverEmail": "t400@mipltest.in",
          "driverProfileImage": "f1c0e81bfd5445b196f01ea35af8c4e1.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Monday",
          "vehicleId": "6ee847b6a4634dcdb25282c2e8924c02",
          "vehicleCode": "MH12 MO9999",
          "vehicleRegistration": "MH12 MO9999",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "TATA",
          "modelName": "Harrier",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "9a167f4c5eee441d8ecdba57e11f5be1",
          "driverFirstName": "User",
          "driverLastName": "driver",
          "driverCode": "DRI11327",
          "driverPhoneNum": "123322312",
          "driverEmail": "t164@mipltest.in",
          "driverProfileImage": "15932402c7b5413493e9e69895dfbf5a.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "924b60aeaa85419aa58ca460b7fc7b57",
          "driverFirstName": "Ewzznz",
          "driverLastName": "Xltpcl - Automation",
          "driverCode": "DRI18318",
          "driverPhoneNum": "9123232858",
          "driverEmail": "t6276@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "MONDAY",
          "vehicleId": "0a8038db285f4a2b8021b7fe570cebc5",
          "vehicleCode": "MP98 RG4548",
          "vehicleRegistration": "MP98 RG4548",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Ford",
          "modelName": "Mustang",
          "capacity": 9,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "8f7493de99914ef18e64f15c028c48a7",
          "driverFirstName": "Vishal",
          "driverLastName": "Driver",
          "driverCode": "DRI27721",
          "driverPhoneNum": "0000012564",
          "driverEmail": "t456@mipltest.in",
          "driverProfileImage": "1502d62d1da74b638010f7e34b318910.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "b098af266b704d6096f6edf51f352168",
          "vehicleCode": "MH12 MO9876",
          "vehicleRegistration": "MH12 MO9876",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "TATA",
          "modelName": "PUNCH",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "8c195dae93284f6ba1a84b82b6dfdb32",
          "driverFirstName": "Ircrab",
          "driverLastName": "Gbcthj - Automation",
          "driverCode": "DRI26516",
          "driverPhoneNum": "3829646511",
          "driverEmail": "t5793@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "WEDNESDAY",
          "vehicleId": "c99e7a48417740459a602281102d94f0",
          "vehicleCode": "MH12AM1221",
          "vehicleRegistration": "MH12AM1221",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "   Maruti",
          "modelName": "   Suzuki",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "89b8b285324241068e32d7ee941e9c01",
          "driverFirstName": "Akshay",
          "driverLastName": "Jadhav",
          "driverCode": "DRI18896",
          "driverPhoneNum": "232323343",
          "driverEmail": "t89@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "87b08d878c8245fc8782cc7f119e1530",
          "driverFirstName": "nitin",
          "driverLastName": "driver",
          "driverCode": "DRI16148",
          "driverPhoneNum": "9960930146",
          "driverEmail": "t103@mipltest.in",
          "driverProfileImage": "6b9c8233d78442d9911e083fd9a9bf6c.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "4a04a9d420334478b15f1339358ee489",
          "vehicleCode": "ZW29 UY8643",
          "vehicleRegistration": "ZW29 UY8643",
          "vehicleType": "Sports-FBOES",
          "vehicleTypeIconName": null,
          "makeModel": "Honda",
          "modelName": "Q7",
          "capacity": 7,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "8496d1ef009b4bc5bfbcf2e6d3869897",
          "driverFirstName": "Test",
          "driverLastName": "Automation",
          "driverCode": "DRI26439",
          "driverPhoneNum": "2343454334",
          "driverEmail": "t343@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "81ef69f340a54faea5ff2469eb2ad1a2",
          "driverFirstName": "Vishal",
          "driverLastName": "Singh",
          "driverCode": "DRI23553",
          "driverPhoneNum": "99998999988",
          "driverEmail": "t566@mipltest.in",
          "driverProfileImage": "6b9c8233d78442d9911e083fd9a9bf6c.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "7ed23104f95b401cab07f429fef02dc1",
          "driverFirstName": "Ohtuac",
          "driverLastName": "Jsiojq - Automation",
          "driverCode": "DRI21427",
          "driverPhoneNum": "9141533761",
          "driverEmail": "t1164@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "MONDAY",
          "vehicleId": "f3e2e619637849bd8ba4e3c0d67e7c3e",
          "vehicleCode": "UJ26 FT5457",
          "vehicleRegistration": "UJ26 FT5457",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Nissan",
          "modelName": "Corolla",
          "capacity": 3,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "7ca998b558954c35ba927977acc8ef8f",
          "driverFirstName": "Vishal",
          "driverLastName": "Singh",
          "driverCode": "DRI21604",
          "driverPhoneNum": "9999898988",
          "driverEmail": "t56@mipltest.in",
          "driverProfileImage": "6b9c8233d78442d9911e083fd9a9bf6c.jpg",
          "dutyStatus": true,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "7bb17aee739443598120be9eccb4d0b4",
          "driverFirstName": "Dev",
          "driverLastName": "Driver32",
          "driverCode": "DRI15151",
          "driverPhoneNum": "12341235",
          "driverEmail": "t32@mipltest.in",
          "driverProfileImage": "b38c5c25259c4fad8178d3e2ff3e428f.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "78edfdf4c8a44b28959e1116399b54cd",
          "driverFirstName": "John",
          "driverLastName": "Test123",
          "driverCode": "DRI13389",
          "driverPhoneNum": "3443233245",
          "driverEmail": "t322@mipltest.in",
          "driverProfileImage": "1d2418ca0c154fb89c9e104a5ef89463.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "eb790da5ec8044fdacb58dd2dd67c2f8",
          "vehicleCode": "MH12 AB 1313",
          "vehicleRegistration": "MH12 AB 1313",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Honda",
          "modelName": "City",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "677e9e551bc24c8b9c0111fe2159ba71",
          "driverFirstName": "Mobi",
          "driverLastName": "Test",
          "driverCode": "DRI26251",
          "driverPhoneNum": "9988776677",
          "driverEmail": "t40@mipltest.in",
          "driverProfileImage": "f1c0e81bfd5445b196f01ea35af8c4e1.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Wednesday",
          "vehicleId": "39a10f5b8f084579af7a04054f5ea454",
          "vehicleCode": "MH12 YB1111",
          "vehicleRegistration": "MH12 YB1111",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Hyundai",
          "modelName": "Venue",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "6316c42f3f484523b2c2f37621de51b2",
          "driverFirstName": "Auto",
          "driverLastName": "driver",
          "driverCode": "DRI14780",
          "driverPhoneNum": "0000122112",
          "driverEmail": "t900@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Monday",
          "vehicleId": "c189ac0d723547c9abe3f1860c978232",
          "vehicleCode": "MH12 QA1122",
          "vehicleRegistration": "MH12 QA1122",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "TATA",
          "modelName": "Nexon",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "53b0952524e94382b3a877da68ebbfa9",
          "driverFirstName": "Amol",
          "driverLastName": "Driver",
          "driverCode": "DRI12196",
          "driverPhoneNum": "2323233232",
          "driverEmail": "t500@mipltest.in",
          "driverProfileImage": "f1c0e81bfd5445b196f01ea35af8c4e1.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Tuesday",
          "vehicleId": "b897484b8b324f6fbad3e0ce7780d519",
          "vehicleCode": "MH12 YB4444",
          "vehicleRegistration": "MH12 YB4444",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "KIA",
          "modelName": "SONET",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "2",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": 1779129000000,
          "weekOffEnd": 1779215399999,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [
            {
              "slotFromDateTime": 1779129000000,
              "slotToDateTime": 1779215399999,
              "slotFromDateTimeStr": "05/19/2026 00:00:00",
              "slotToDateTimeStr": "05/19/2026 23:59:59",
              "shiftType": "2",
              "periodType": "weekOff"
            }
          ],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "4915f9b678ad49598771be6e77c7101b",
          "driverFirstName": "Dev",
          "driverLastName": "Driver37",
          "driverCode": "DRI11420",
          "driverPhoneNum": "7474575710",
          "driverEmail": "t37@mipltest.in",
          "driverProfileImage": "5a68689e18f44700a1628beb2c3e6cae.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "3bc8dd13e24f49f1800932e8c4c40780",
          "driverFirstName": "David",
          "driverLastName": "Test",
          "driverCode": "DRI27053",
          "driverPhoneNum": "2334545676",
          "driverEmail": "t567@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Tuesday",
          "vehicleId": "ceea1c315cac49b096cf889d60dc79c7",
          "vehicleCode": "MH12 WW2345",
          "vehicleRegistration": "MH12 WW2345",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Maruti",
          "modelName": "Dzire",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": 1779129000000,
          "weekOffEnd": 1779215399999,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [
            {
              "slotFromDateTime": 1779129000000,
              "slotToDateTime": 1779215399999,
              "slotFromDateTimeStr": "05/19/2026 00:00:00",
              "slotToDateTimeStr": "05/19/2026 23:59:59",
              "shiftType": "16",
              "periodType": "weekOff"
            }
          ],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "35f931921484448b8eb8d13c5d813671",
          "driverFirstName": "Auto",
          "driverLastName": "test",
          "driverCode": "DRI20313",
          "driverPhoneNum": "2332455456",
          "driverEmail": "t433@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": "7bf07fd46afd4e3cb272266407cd6333",
          "vehicleCode": "DX82 PD7185",
          "vehicleRegistration": "DX82 PD7185",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Chevrolet",
          "modelName": "Civic",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "35c25c787a9347a1991b9f4f808851e8",
          "driverFirstName": "Dvoffn",
          "driverLastName": "Zppxqy - Automation",
          "driverCode": "DRI10566",
          "driverPhoneNum": "2538485672",
          "driverEmail": "t2843@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "TUESDAY",
          "vehicleId": "6f76e2cbef76449ea19a04177ab04903",
          "vehicleCode": "MH12 QA3333",
          "vehicleRegistration": "MH12 QA3333",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Maruti",
          "modelName": "Baleno",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": 1779129000000,
          "weekOffEnd": 1779215399999,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [
            {
              "slotFromDateTime": 1779129000000,
              "slotToDateTime": 1779215399999,
              "slotFromDateTimeStr": "05/19/2026 00:00:00",
              "slotToDateTimeStr": "05/19/2026 23:59:59",
              "shiftType": "24",
              "periodType": "weekOff"
            }
          ],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "31f12116ee8d493687791c9da201e74d",
          "driverFirstName": "John",
          "driverLastName": "Driver",
          "driverCode": "DRI27339",
          "driverPhoneNum": "9898989977",
          "driverEmail": "t27@mipltest.in",
          "driverProfileImage": "5a68689e18f44700a1628beb2c3e6cae.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "a69e17ab319d45a4b89bfc0179888d57",
          "vehicleCode": "MH12 AB0909",
          "vehicleRegistration": "MH12 AB0909",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Mahindra",
          "modelName": "XUV 700",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "25601efd396f44838058e8d68d075a34",
          "driverFirstName": "Eqfwlu",
          "driverLastName": "Olfmxc - Automation",
          "driverCode": "DRI12844",
          "driverPhoneNum": "9167159784",
          "driverEmail": "t7016@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "FRIDAY",
          "vehicleId": "d126b08191104a4488322a5a080bf09c",
          "vehicleCode": "RV57 FY5867",
          "vehicleRegistration": "RV57 FY5867",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Chevrolet",
          "modelName": "Mustang",
          "capacity": 7,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "21d6c773d9424745bafbf720e3caae18",
          "driverFirstName": "tEST18",
          "driverLastName": "121",
          "driverCode": "DRI14349",
          "driverPhoneNum": "8635636354656",
          "driverEmail": "THH@VV.IN",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "18cc2f441fb5406aa68dc39df360e3cb",
          "driverFirstName": "Yogesh",
          "driverLastName": "Driver",
          "driverCode": "DRI24559",
          "driverPhoneNum": "9900876767",
          "driverEmail": "t41@mipltest.in",
          "driverProfileImage": "f1c0e81bfd5445b196f01ea35af8c4e1.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "d4a7e30f49e14fd197f15df425a5c1cc",
          "vehicleCode": "MH12 AB9999",
          "vehicleRegistration": "MH12 AB9999",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Mahindra",
          "modelName": "XUV 700",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "1",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "184d06f26b344b9688cc1de95cba1ebe",
          "driverFirstName": "Miller",
          "driverLastName": "Test",
          "driverCode": "DRI22733",
          "driverPhoneNum": "0002334123",
          "driverEmail": "t858@mipltest.in",
          "driverProfileImage": "",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "6aca2c4160ab4b75b5acd0e288307b27",
          "vehicleCode": "MH12 MO3412",
          "vehicleRegistration": "MH12 MO3412",
          "vehicleType": "Voxy 6 Pax",
          "vehicleTypeIconName": null,
          "makeModel": "MARUTI",
          "modelName": "BALENO",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "24",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "159ce5f8a2f849e8a548b92343a7bab0",
          "driverFirstName": "Mac",
          "driverLastName": "Smith",
          "driverCode": "DRI11810",
          "driverPhoneNum": "12541025251",
          "driverEmail": "mac@mi2.in",
          "driverProfileImage": "fcb1d6fb2c0b473abfe9c6c6e7b17ed7.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": null,
          "vehicleCode": null,
          "vehicleRegistration": null,
          "vehicleType": null,
          "vehicleTypeIconName": null,
          "makeModel": null,
          "modelName": null,
          "capacity": null,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "1247d3fa3c664a8a8f70cc2a97ee1d2c",
          "driverFirstName": "Charli",
          "driverLastName": "Test",
          "driverCode": "DRI22080",
          "driverPhoneNum": "2242582938",
          "driverEmail": "t7701@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "299278d02db9411b9ae3c5f8e17625a1",
          "vehicleCode": "MH12 MO4545",
          "vehicleRegistration": "MH12 MO4545",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Honda",
          "modelName": "City",
          "capacity": 6,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "12165475878f40fcbf02eba8665bb02c",
          "driverFirstName": "Hjxjau",
          "driverLastName": "ZcgldyAutomation",
          "driverCode": "DRI14331",
          "driverPhoneNum": "4661274915",
          "driverEmail": "t4979@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": "148ca568cd154aabb926564d373737e3",
          "vehicleCode": "MH12AB099",
          "vehicleRegistration": "MH12AB099",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "TATA",
          "modelName": "PUNCH",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "0cfbb592da9e48f59bee43dfe8383224",
          "driverFirstName": "Tgcsff",
          "driverLastName": "Dcgbex - Automation",
          "driverCode": "DRI13733",
          "driverPhoneNum": "6457729284",
          "driverEmail": "t8513@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "MONDAY",
          "vehicleId": "04a3757d7c9f40d285e437951859b303",
          "vehicleCode": "QV53 EU3684",
          "vehicleRegistration": "QV53 EU3684",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Mercedes",
          "modelName": "Mustang",
          "capacity": 6,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "07598b21e88c4f0781d19c75407bf5fd",
          "driverFirstName": "Aqoiyi",
          "driverLastName": "Ijmvea - Automation",
          "driverCode": "DRI25398",
          "driverPhoneNum": "4432243476",
          "driverEmail": "t1541@mipltest.in",
          "driverProfileImage": "d80d0105f98e4fa2a5b1564784053532.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "THURSDAY",
          "vehicleId": "6acae55f32ae4a5caf071987264efdff",
          "vehicleCode": "SU47 HP8122",
          "vehicleRegistration": "SU47 HP8122",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Honda",
          "modelName": "Corolla",
          "capacity": 9,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "069eb1600a0b45bca68dcd0bfd3a09c9",
          "driverFirstName": "Mobi",
          "driverLastName": "123",
          "driverCode": "DRI22501",
          "driverPhoneNum": "1122335566",
          "driverEmail": "t181@mipltest.in",
          "driverProfileImage": "043396e36f8148b3a756e74737e71541.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": null,
          "vehicleId": "752b20f7e8d44291a2a24dd899698418",
          "vehicleCode": "123",
          "vehicleRegistration": "123",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "Swift",
          "modelName": "SSI",
          "capacity": 4,
          "vehicleImage": null,
          "shiftType": null,
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        },
        {
          "tenantId": "teac954391bb4dfb8517ee993ccb92b1",
          "driverId": "0232abcf41434b269d67f814dc273937",
          "driverFirstName": "Andrew",
          "driverLastName": "Driver",
          "driverCode": "DRI22053",
          "driverPhoneNum": "002324334",
          "driverEmail": "t930@mipltest.in",
          "driverProfileImage": "abc74e880f53460798119c38c832817a.jpg",
          "dutyStatus": false,
          "driverDutyStatus": null,
          "driverWeeklyOff": "Sunday",
          "vehicleId": "daa87927fbaf44f28e21d6599b0af8cc",
          "vehicleCode": "MH12 MO9988",
          "vehicleRegistration": "MH12 MO9988",
          "vehicleType": "Salon",
          "vehicleTypeIconName": null,
          "makeModel": "MARUTI",
          "modelName": "DZIRE",
          "capacity": 5,
          "vehicleImage": null,
          "shiftType": "16",
          "workStart": null,
          "workEnd": null,
          "restStart": null,
          "restEnd": null,
          "weekOffStart": null,
          "weekOffEnd": null,
          "driverShiftCycleStr": null,
          "driverShiftCycleList": [],
          "tourList": [],
          "bookingCount": 0
        }
      ],
      "unassignedTourCount": 3,
      "vehicleDetailsCount": 0,
      "driverDetailsCount": 59,
      "limit": 1000,
      "offset": 0
    }
}
